import { jobStatusNames } from '../../common/constants/jobStatusNames';

// `job.error` is the job's one JobErrors row, written by the parse step; it is null until a PDF has been parsed

/** Parser status of a job: a `jobs:jobErrors.flags.*` key. */
export const getParserStatusFlag = job => {
    if (!job?.error) {
        return 'pending';
    }

    return job.error.isParserError ? 'error' : 'noError';
};

/** Report status of a job: a `jobs:jobErrors.flags.*` key and the Tag color the Orders list shows it in. */
export const getReportStatus = job => {
    if (job?.status?.name === jobStatusNames.Rejected) {
        return { flag: 'rejected', color: 'volcano' };
    }

    if (job?.error?.isSupportedType === false) {
        return { flag: 'unsupported', color: 'warning' };
    }

    const isReady = job?.error?.isParserReportReady;

    if (isReady === undefined || isReady === null) {
        return { flag: 'pending', color: 'processing' };
    }

    return isReady ? { flag: 'ready', color: 'success' } : { flag: 'notReady', color: 'error' };
};
